<div class="lb--header">
  <span class="tf2hunt--lightning"></span>
  <h3 class="typography-title">Live Bets</h3>
</div>
<div class="lb--divider divider horizontal w-full"></div>
<div class="tf2hunt--table">
  @if(bets().length > 0) {
  <div class="tf2hunt--table__header">
    <div class="tf2hunt--table__header--col">Game</div>
    <div class="tf2hunt--table__header--col">Player</div>
    <div class="tf2hunt--table__header--col">Time</div>
    <div class="tf2hunt--table__header--col">Wager</div>
    <div class="tf2hunt--table__header--col">Multiplier</div>
    <div class="tf2hunt--table__header--col">Payout</div>
  </div>
  }
  <div class="tf2hunt--table__body" [@listAnimation]="modifiedBets().length">
    @for (bet of modifiedBets(); track $index) {
    <div class="tf2hunt--table__body--row">
      <div
        (click)="bet.handleNavigate()"
        class="tf2hunt--table__body--col col-game"
      >
        <app-game-icon [game]="bet.game"></app-game-icon>
        <p>{{ bet.game }}</p>
      </div>
      <div class="tf2hunt--table__body--col col-player">
        <app-player-row
          style="cursor: pointer"
          (click)="contextMenuService.open($event, { user: bet })"
          [player]="bet"
        ></app-player-row>
      </div>
      <div class="tf2hunt--table__body--col col-time">
        <span>{{ bet.time * 1000 | date : "shortTime" }}</span>
      </div>
      <div class="tf2hunt--table__body--col col-wager">
        <app-balance-icon [balance]="bet.baltype"></app-balance-icon>
        {{ bet.bet | number : "1.2-2" }}
      </div>
      <div class="tf2hunt--table__body--col col-multiplier">
        @if (bet.mult) {
        <span
          class="box-yellow-08 padding-x-8 rounded-4 flex items-center gap-4"
          style="border: 1px solid transparent"
        >
          {{ bet.mult | number : "1.0-1" }} x
        </span>
        } @else {
        <span
          class="box-white-04 padding-x-8 rounded-4 flex items-center justify-center"
          style="border: 1px solid transparent"
          >-</span
        >
        }
      </div>
      <div class="tf2hunt--table__body--col col-payout">
        <app-balance-icon [balance]="bet.baltype"></app-balance-icon>
        <span [style.color]="bet.profit ? 'var(--green)' : 'var(--red)'">
          {{ (bet.profit ? bet.profit : -bet.bet) | number : "1.2-2" }}
        </span>
      </div>
    </div>
    }
  </div>
</div>
